import { Component, OnInit, ViewChild } from '@angular/core';
import { VoucherAutomatico } from '../models/voucher-automativo';
import { VoucherAutomaticoService } from '../services/voucher-automatico.service';
import { NotificacaoService } from '../services/notificacao.service';
import { CarregandoService } from '../services/carregando.service';
import { UtilitarioService } from '../services/utilitario.service';
import { MatDialog, MatPaginator, PageEvent } from '@angular/material';
import { CadastrarVoucherAutomaticoModalComponent } from '../modals/cadastrar-voucher-automatico-modal/cadastrar-voucher-automatico-modal.component';
import swal from 'sweetalert2';
import { PremissasService } from '../services/premissas.service';
import { Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { PaginatorService } from '../services/paginator.service';

declare const $: any;

@Component({
  selector: 'app-vouchers-automaticos',
  templateUrl: './vouchers-automaticos.component.html',
  styleUrls: ['./vouchers-automaticos.component.scss']
})
export class VouchersAutomaticosComponent implements OnInit {

  vouchers: VoucherAutomatico[] = [];

  descricaoBusca: string;

  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  campoOrdenacao = 'descricao';
  ordenarDesc = false;

  public config: PerfectScrollbarConfigInterface = {};

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    private voucherAutomaticoService: VoucherAutomaticoService,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private utilitarioService: UtilitarioService,
    private premissasService: PremissasService,
    private router: Router,
    private dialog: MatDialog,
    private paginatorService: PaginatorService
  ) { }

  ngOnInit(): void {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarVouchersAutomaticos();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarVouchersAutomaticos();
  }

  buscarVouchersAutomaticos() {
    this.carregandoService.mostra('buscarVouchersAutomaticos');

    this.voucherAutomaticoService.consultarComPaginacao(this.descricaoBusca, this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc').subscribe(
      dados => {
        this.vouchers = dados.itens;

        if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
          this.itensPorPagina = 10;
        }

        this.paginacao.total = dados.total;
        this.carregandoService.esconde('buscarVouchersAutomaticos');
      },
      err => {
        this.carregandoService.esconde('buscarVouchersAutomaticos');
        this.notificacaoService.erro(err);
      }
    );
  }

  novoVoucher() {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(CadastrarVoucherAutomaticoModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      panelClass: 'modal-card',
      data: {}
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) { this.buscarVouchersAutomaticos(); }
    });
  }

  editarVoucher(voucher: VoucherAutomatico) {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(CadastrarVoucherAutomaticoModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      panelClass: 'modal-card',
      data: {
        idVoucherAutomatico: voucher.id
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) { this.buscarVouchersAutomaticos(); }
    });
  }

  excluirVoucher(voucher: VoucherAutomatico) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir o Voucher Automático?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluirVoucher');
        this.voucherAutomaticoService.excluir(voucher.id).subscribe(resp => {
          this.notificacaoService.sucesso('Voucher Automático excluído com sucesso!!!');
          this.carregandoService.esconde('excluirVoucher');
          this.buscarVouchersAutomaticos();
        }, (erro) => {
          this.carregandoService.esconde('excluirVoucher');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }
}
